import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ChangePasswordFormComponent } from '../../change-password/change-password-form/change-password-form.component';

@Component({
  selector: 'change-password-modal',
  templateUrl: 'change-password-modal.component.html',
  imports: [ChangePasswordFormComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChangePasswordModalComponent {
  private readonly dialogRef = inject(DynamicDialogRef);

  passwordChanged(result: { password: string }): void {
    this.dialogRef.close(result.password);
  }
}
